export default "__VITE_ASSET__Dnk6c8dZ__"